import { render } from "./PlatformMonitoring.vue?vue&type=template&id=e0125f5a&scoped=true&ts=true"
import script from "./PlatformMonitoring.vue?vue&type=script&lang=ts"
export * from "./PlatformMonitoring.vue?vue&type=script&lang=ts"

import "./PlatformMonitoring.vue?vue&type=style&index=0&id=e0125f5a&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0125f5a"]])

export default __exports__